import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'streaming-as-backbone',
  category: 'event-talks',
  title: 'Streaming as the Backbone of Autonomous AI Agents',
  speaker: 'Sijie Guo · StreamNative',
  description: 'A 15–20 minute talk on enterprise agentic infrastructure.',
  date: '2026-05-12',
  context: 'Streaming the Future · San Francisco · Aiven · StreamNative · RisingWave',
  visibility: 'public',
  slides,
};

export default deck;
